<template>
  <div>
    <Slide />
    <About />
    <Gallery />
    <Pressa />
    <Videos /> 
    <Contacts />
  </div>
</template>

<script>
  import About from '@/views/About'
  import Gallery from '@/views/Gallery'
  import Pressa from '@/views/Pressa' 
  import Videos from '@/views/Videos'
  import Slide from '@/views/Slide'  
  import Contacts from '@/views/Contacts' 

  export default {
    name: 'Home',
      components: {
        About, Gallery, Pressa, Videos, Slide, Contacts
      }
  }
</script>
